module.exports = __webpack_public_path__ + "images/company_profile/icon_en09-4317659e355ce9b397ae10d5b6c73803.png";